/**
 * Randomly selects one-third of products in a collection and sets their second image as the main thumbnail
 */
function initializeRandomSecondImages() {
  // Get all product blocks on the page
  const productBlocks = document.querySelectorAll('product-block');
  
  if (!productBlocks.length) return;

  // Calculate how many products should show second image (1/2 of total)
  const productsToChange = Math.floor(productBlocks.length / 2);
  
  // Create array of indices and shuffle it
  const indices = Array.from({ length: productBlocks.length }, (_, i) => i);
  for (let i = indices.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [indices[i], indices[j]] = [indices[j], indices[i]];
  }
  
  // Take first third of shuffled indices
  const selectedIndices = indices.slice(0, productsToChange);
  
  // Process each selected product block
  selectedIndices.forEach(index => {
    const productBlock = productBlocks[index];
    const secondImage = productBlock.querySelector('.product-block__image--secondary');
    const primaryImage = productBlock.querySelector('.product-block__image--primary');
    
    if (secondImage && primaryImage) {
      // Remove active class from primary image
      primaryImage.classList.remove('product-block__image--active');
      
      // Add active class to second image and remove inactivated class
      secondImage.classList.remove('product-block__image--inactivated');
      secondImage.classList.add('product-block__image--active');
      
      // Update image dots if they exist
      const imageDots = productBlock.querySelectorAll('.product-block__image-dot');
      if (imageDots.length >= 2) {
        imageDots[0].classList.remove('product-block__image-dot--active');
        imageDots[1].classList.add('product-block__image-dot--active');
      }
    }
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeRandomSecondImages);
} else {
  initializeRandomSecondImages();
}